import { render } from "./RoleAddData.vue?vue&type=template&id=7d7f8274&scoped=true"
import script from "./RoleAddData.vue?vue&type=script&lang=js"
export * from "./RoleAddData.vue?vue&type=script&lang=js"

import "./RoleAddData.vue?vue&type=style&index=0&id=7d7f8274&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d7f8274"]])

export default __exports__